import { Link, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page bg-light min-vh-100 d-flex align-items-center">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8} lg={6}>
            <div className="not-found-content py-5">
              <div className="not-found-icon mb-4">
                <i className="bi bi-exclamation-triangle display-1 text-danger"></i>
              </div>

              <h1 className="display-4 fw-bold text-dark mb-3">404</h1>
              <h2 className="h4 text-muted mb-4">Page Not Found</h2>

              <p className="text-muted mb-4">
                The page you're looking for doesn't exist or has been moved.
                Let's get you back on track.
              </p>

              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-5">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => navigate(-1)}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Go Back
                </Button>
                <Button
                  as={Link}
                  to="/"
                  variant="outline-primary"
                  size="lg"
                >
                  <i className="bi bi-house me-2"></i>
                  Home
                </Button>
              </div>

              <hr className="my-4" />

              <p className="text-muted mb-3">Or try one of these:</p>

              <div className="quick-links d-flex flex-wrap justify-content-center gap-2">
                <Link to="/products" className="btn btn-outline-secondary btn-sm">
                  <i className="bi bi-box-seam me-1"></i>
                  All Products
                </Link>
                <Link to="/categories" className="btn btn-outline-secondary btn-sm">
                  <i className="bi bi-grid me-1"></i>
                  Categories
                </Link>
                <Link to="/brands" className="btn btn-outline-secondary btn-sm">
                  <i className="bi bi-tags me-1"></i>
                  Brands
                </Link>
                <Link to="/account" className="btn btn-outline-secondary btn-sm">
                  <i className="bi bi-person me-1"></i>
                  My Account
                </Link>
                <Link to="/account/orders" className="btn btn-outline-secondary btn-sm">
                  <i className="bi bi-receipt me-1"></i>
                  Orders
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <style>{`
        .not-found-page {
          padding: 2rem 0;
        }

        .not-found-icon {
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.8;
          }
        }

        .quick-links .btn {
          transition: all 0.2s ease;
        }

        .quick-links .btn:hover {
          transform: translateY(-2px);
        }
      `}</style>
    </div>
  );
};

export default NotFoundPage;